import type { useNavigate } from '@tanstack/react-router';
import { orgRoute } from './org-route';

// Thin navigation helpers. The tenant-scoped paths are wrapped in
// orgRoute() so navigation always carries the signed-in tenant's
// slug as the first URL segment (/acme/fleet etc). TanStack Router's
// typed-route system requires a generic `from` parameter that
// callers don't have; the cast keeps screen bodies declarative.
//
// When a route's search params change, the cast surface narrows to
// this file rather than every screen that navigates there.

type Nav = ReturnType<typeof useNavigate>;
type NavOpts = Parameters<Nav>[0];

export function goAttention(nav: Nav) {
  nav({ to: orgRoute('/') } as unknown as NavOpts);
}

export function goAttentionEvidence(nav: Nav, alertId: string) {
  nav({
    to: orgRoute('/'),
    search: { evidence: true, alert: alertId },
  } as unknown as NavOpts);
}

export function goFleet(nav: Nav) {
  nav({ to: orgRoute('/fleet'), search: { view: 'cards' } } as unknown as NavOpts);
}

export function goAsset(nav: Nav, assetId: string) {
  nav({ to: orgRoute(`/assets/${assetId}`) } as unknown as NavOpts);
}

export function goAlert(nav: Nav, alertId: string) {
  nav({ to: orgRoute(`/alerts/${alertId}`) } as unknown as NavOpts);
}

export function goAnalyze(nav: Nav, assetId?: string) {
  // `asset` is the search param S5 reads to pick the workbench's
  // active asset (see routes/$orgId.analyze.tsx validateSearch).
  nav({
    to: orgRoute('/analyze'),
    search: assetId ? { asset: assetId } : {},
  } as unknown as NavOpts);
}

export function goInbox(nav: Nav) {
  nav({ to: orgRoute('/inbox') } as unknown as NavOpts);
}

export function goSearch(nav: Nav, query?: string) {
  nav({ to: orgRoute('/search'), search: query ? { q: query } : {} } as unknown as NavOpts);
}
